const PIXEL_ID = '1289014065944251'

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

function loadPixelScript(): Promise<void> {
  return new Promise((resolve) => {
    if (window.fbq) {
      resolve()
      return
    }

    // Initialize fbq queue
    const n: any = (window.fbq = function () {
      if (n.callMethod) {
        n.callMethod.apply(n, arguments)
      } else {
        n.queue.push(arguments)
      }
    })
    if (!window._fbq) window._fbq = n
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []

    // Load the script
    const script = document.createElement('script')
    script.async = true
    script.src = 'https://connect.facebook.net/en_US/fbevents.js'
    script.onload = () => resolve()
    script.onerror = () => resolve() // resolve anyway so we don't block
    document.head.appendChild(script)

    // Also add noscript fallback pixel
    const noscriptImg = document.createElement('img')
    noscriptImg.height = 1
    noscriptImg.width = 1
    noscriptImg.style.display = 'none'
    noscriptImg.src = `https://www.facebook.com/tr?id=${PIXEL_ID}&ev=PageView&noscript=1`
    document.body.appendChild(noscriptImg)
  })
}

let initialized = false

export async function initPixel() {
  if (initialized) return
  initialized = true

  await loadPixelScript()
  window.fbq('init', PIXEL_ID)
}

export function trackPageView() {
  if (window.fbq) {
    window.fbq('track', 'PageView')
  }
}

export function trackEvent(event: string, data?: Record<string, unknown>) {
  if (window.fbq) {
    window.fbq('track', event, data)
  }

  // Fire a direct image pixel as backup to ensure the event registers
  // even if the script hasn't fully loaded
  const params = new URLSearchParams({
    id: PIXEL_ID,
    ev: event,
    noscript: '1',
  })
  if (data) {
    Object.entries(data).forEach(([key, value]) => {
      params.append(`cd[${key}]`, String(value))
    })
  }
  const img = new Image()
  img.src = `https://www.facebook.com/tr?${params.toString()}`
}
